// @flow
import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_DATA_ANALYTICS: `${env.baseApiUrl}/im/admin/analytics/dashboard/main`,
  GET_SUMMARY_PRODUCTS: `${env.baseApiUrl}/im/admin/analytics/dashboard/summary/products`,
  GET_SUMMARY_ORDERS: `${env.baseApiUrl}/im/admin/analytics/dashboard/summary/orders`,
  GET_SUMMARY_PRODUCT_CATEGORIES: `${env.baseApiUrl}/im/admin/analytics/dashboard/summary/product-categories`,
  GET_SUMMARY_SALES: `${env.baseApiUrl}/im/admin/analytics/dashboard/summary/sales`,
  GET_PAGE_VIEWS: `${env.baseApiUrl}/im/admin/analytics/page-views`,
  //DASHBOARD PLUS
  GET_SUMMARY_PRODUCT_COUNT: `${env.baseApiUrl}/im/admin/analytics/dashboard/summary/count-products`,
  GET_SUMMARY_ORDER_AMOUNT: `${env.baseApiUrl}/im/admin/order/amount`,
  GET_SUMMARY_AVERAGE_TICKET: `${env.baseApiUrl}/im/admin/order/average-ticket`,
  GET_SUMMARY_ORDER_CUSTOMERS: `${env.baseApiUrl}/im/admin/analytics/dashboard/top-customers`,
  GET_FLAG_LESS_STOCK_PRODUCTS: `${env.baseApiUrl}/im/admin/analytics/dashboard/products-stock-validation`,
  GET_SUMMARY_LESS_STOCK_PRODUCTS: `${env.baseApiUrl}/im/admin/analytics/dashboard/less-stock-products`,
  GET_SUMMARY_PAGE_VIEWS: `${env.baseApiUrl}/im/admin/analytics/dashboard/summary/views`,
  GET_SUMMARY_MOST_SEEN_PRODUCTS: `${env.baseApiUrl}/im/admin/analytics/dashboard/summary/products-views`,
  GET_COUPON_SALES: `${env.baseApiUrl}/im/admin/analytics/dashboard/sales-coupon`,
  GET_PROMOTION_SALES: `${env.baseApiUrl}/im/admin/analytics/dashboard/sales-promotion`,

  COMPLETE_FIRST_STEPS: `${env.baseApiUrl}/ui/admin/store/first-steps`,
  DOMAIN_EXPOSITION: `${env.baseApiUrl}/ui/admin/store/domain-exposition`,
  COMPLETED_CONFIG: `${env.baseApiUrl}/ui/admin/store/meta`,
});

export const fetchProductsCountApi = getCreator(
  endpoints.GET_SUMMARY_PRODUCT_COUNT
);
export const fetchDataAnalyticsApi = getCreator(endpoints.GET_DATA_ANALYTICS);
export const fetchPageViewsApi = getCreator(endpoints.GET_PAGE_VIEWS);
export const fetchSummaryProductsApi = getCreator(
  endpoints.GET_SUMMARY_PRODUCTS
);
export const fetchSummaryMostSeenProductsApi = getCreator(
  endpoints.GET_SUMMARY_MOST_SEEN_PRODUCTS
);
export const fetchSummaryOrdersApi = getCreator(endpoints.GET_SUMMARY_ORDERS);
export const fetchSummaryProductCategoriesApi = getCreator(
  endpoints.GET_SUMMARY_PRODUCT_CATEGORIES
);
export const fetchSummarySalesApi = getCreator(endpoints.GET_SUMMARY_SALES);
export const fetchSummaryOrderAmountApi = getCreator(
  endpoints.GET_SUMMARY_ORDER_AMOUNT
);
export const fetchSummaryAverageTicketApi = getCreator(
  endpoints.GET_SUMMARY_AVERAGE_TICKET
);
export const fetchSummaryOrderCustomersApi = getCreator(
  endpoints.GET_SUMMARY_ORDER_CUSTOMERS
);
export const fetchFlagLessStockProductsApi = getCreator(
  endpoints.GET_FLAG_LESS_STOCK_PRODUCTS
);
export const fetchSummaryLessStockProductsApi = getCreator(
  endpoints.GET_SUMMARY_LESS_STOCK_PRODUCTS
);
export const fetchSummaryPagesViewsApi = getCreator(
  endpoints.GET_SUMMARY_PAGE_VIEWS
);
export const fetchPromotionSalesApi = getCreator(endpoints.GET_PROMOTION_SALES);
export const fetchCouponSalesApi = getCreator(endpoints.GET_COUPON_SALES);
export const completeFirstStepsApi = postCreator(
  endpoints.COMPLETE_FIRST_STEPS
);
export const fetchCompleteFirstStepsApi = getCreator(
  endpoints.COMPLETE_FIRST_STEPS
);
export const domainExpositionApi = postCreator(endpoints.DOMAIN_EXPOSITION);
export const fetchDomainExpositionApi = getCreator(endpoints.DOMAIN_EXPOSITION);
export const saveCompletedConfigApi = postCreator(endpoints.COMPLETED_CONFIG);
export const fetchCompletedConfigApi = getCreator(endpoints.COMPLETED_CONFIG);
